export class EnumUtility {
  public static GetEnumMemberName(
    enumObj: any,
    value: number
  ): string | undefined {
    return Object.keys(enumObj).find((key) => enumObj[key] === value);
  }
}
